<div class="ticket-list">
  <ng-container
    fgbDataSource
    [dataSource]="ticketList$ | async"
    [filters]="filters"
    [sortOptions]="sortOptions"
    (dataSourceChange)="onDataChange.emit($event)"
  >
    <ng-template let-tickets>
      @if (tickets?.length > 0) {
        <ng-container *ngFor="let ticket of tickets">
          <fgbcl-ticket-list-item
            [ticket]="ticket"
            [transferWindowExists]="transferWindowExists"
            [transferWindowOpen]="transferWindowOpen"
            [ticketColumn1]="ticketColumn1"
            [ticketColumn2]="ticketColumn2"
          ></fgbcl-ticket-list-item>
        </ng-container>
      } @else {
        <ng-content select=".ticket-list-no-data"></ng-content>
      }
    </ng-template>
  </ng-container>
</div>
